export const PortalCookies: PortalCookiesModel = {
  crmIntegrations: 'IntegrationsAnnouncement',
  amplitudeSurveyCompleted: 'amplitudeSurveyCompleted',
  annualStatementAnnouncementSeen: 'annualStatementAnnouncementSeen',
  eoExpirationAnnouncement: 'eoExpirationAnnouncement',
  redtailLifecycleFullRelease: 'redtailLifecycleFullRelease',
};

interface PortalCookiesModel {
  crmIntegrations: 'IntegrationsAnnouncement',
  amplitudeSurveyCompleted: 'amplitudeSurveyCompleted',
  annualStatementAnnouncementSeen: 'annualStatementAnnouncementSeen',
  eoExpirationAnnouncement: 'eoExpirationAnnouncement',
  redtailLifecycleFullRelease: 'redtailLifecycleFullRelease',
}